import { combineReducers } from 'redux';
import inbox from './inbox';
import review from './review';

export default combineReducers({
    inbox,
    review
});
